/**
 * Формула коэффициента аннуитета:
 * К = (i * (1 + i)^n) / ((1+i)^n-1)
 * где i – процентная ставка за месяц, результат деления годовой ставки на 12;
 * n – срок кредита в месяцах.
 */
function getAnnuityFactor(rate, term) {
  const i = rate / 12 / 100;
  const n = term;
  return i * (1 + i) ** n / ((1 + i) ** n - 1);
}

/**
   * Месячный платеж по аннуитету
   * sum * annuityFactor
   */
export function getAnnuityMonthPayment(sum, rate, term) {
  const factor = getAnnuityFactor(rate, term);
  return sum * factor;
}
// getAnnuityMonthPayment
// этот надо вызывать
// sum - цена тачки минус аванс
// rate - до 10 лет 40%, до 17 - 45%, иначе - 49%
// ß - 84

export function getAnnuityRate(year) {
  const currentYear = new Date().getFullYear();
  const diff = currentYear - year;
  if (diff <= 17) return 45;
  if (diff <= 10) return 40;
  return 49;
}



// WEBPACK FOOTER //
// ./src/shared/helpers/leasing/myAutoCalculate.js